import React, { useState } from "react";
import "./Input.css";
import { CopyIcon2, CheckIcon } from "../../icons/reactIcons";

interface InputProps {
  type: string;
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  search?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  required?: boolean;

  showPassword?: boolean;
  onTogglePassword?: () => void;
  name?: string;
  copy?: boolean;
  removeBottomMargin?: boolean;
}

const Input: React.FC<InputProps> = ({
  type,
  label,
  placeholder,
  value,
  onChange,
  search = false,
  startIcon,
  endIcon,
  required = false,
  showPassword,
  onTogglePassword,
  name,
  copy = false,
  removeBottomMargin = false,
}) => {
  const isPassword = type === "password";
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1500);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div
      className="input-container"
      style={{ marginBottom: removeBottomMargin ? " " : "20px" }}
    >
      {label && (
        <div className="custom-input-label">
          <label className="input-label">
            {label}
            {required && <span className="required">*</span>}
          </label>

          {copy && (
            <span
              className="copy-icon clickable"
              onClick={handleCopy}
              title={copied ? "Copied!" : "Copy"}
            >
              {copied ? (
                <CheckIcon />
              ) : (
                <CopyIcon2 style={{ cursor: "pointer" }} />
              )}
            </span>
          )}
        </div>
      )}

      <div className="input-wrapper">
        {startIcon && search && (
          <span className="input-icon start-icon">{startIcon}</span>
        )}

        <input
          className="custom-input"
          name={name}
          type={isPassword && showPassword ? "text" : type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={{
            width: search ? "400px" : "",
            paddingLeft: search ? "40px" : "20px",
            paddingRight: endIcon ? "40px" : "20px",
          }}
        />

        {endIcon && (
          <span
            className="input-icon end-icon clickable"
            onClick={isPassword ? onTogglePassword : undefined}
          >
            {endIcon}
          </span>
        )}
      </div>
    </div>
  );
};

export default Input;
